import { SortingState } from "@tanstack/react-table";

export const DEFAULT_ORDERING = "-specimens__collected_date";

export type CaseAccessionFiltersState = {
  status?: string;
  clinicId?: number;
  collectedAt?: string;
  search?: string;
  pageSize: number;
  pageCount: number;
  currentPage: number;
  sorting?: SortingState;
};

export const defaultCaseAccessionFilters: CaseAccessionFiltersState = {
  status: undefined,
  clinicId: undefined,
  collectedAt: undefined,
  search: "",
  pageSize: 10,
  pageCount: 0,
  currentPage: 1,
  sorting: [
    {
      id: "specimens__collected_date",
      desc: true,
    },
  ],
};
